import axios from "axios";
// Entities
import { PiecesAndReferences } from "@/entities/index";

export async function getPiecesAndReferences({
  client,
  warehouse,
  integrateStepZero,
}: {
  client: string;
  warehouse: string;
  integrateStepZero: boolean;
}): Promise<{ reasons: string[]; pieces: number[]; references: number[] }> {
  const { reasons, pieces, references } = (
    await axios.post(`/api/dashboards/chart2`, {
      client,
      warehouse,
      integrateStepZero,
    })
  ).data as PiecesAndReferences;

  return { reasons, pieces, references };
}
